module.exports = __webpack_public_path__ + "static/media/icon_lock.6e8e06d4.svg";